module.exports = __webpack_public_path__ + "static/media/img-13.8a92be8d.png";